import PartidasArancelariasService from '@/services/PartidasArancelariasService';

export const namespaced = true;

export const state = {
  partidasArancelarias: [],
  partidasArancelariasFlat: [],
  loadingCapitulos: false,
  loadingPartidas: false,
};

const mapPartidas = cap => {
    cap['nombreResumido'] = cap.nombreTecnico.split('\n')[0];
    if (!cap.esHoja) {
      cap['children'] = [];
    }
    return cap; };


export const mutations = {
  SET_CAPITULOS(state, capitulos) {
    state.partidasArancelarias = capitulos;
    state.partidasArancelariasFlat = capitulos;
  },
  SET_PARTIDAS_ARANCELARIAS(state, partidasArancelarias) {
    state.partidasArancelarias = partidasArancelarias;
  },
  ADD_PARTIDAS(state, partidas) {
    state.partidasArancelariasFlat.push(...partidas);
  },
  SET_LOADING_CAPITULOS(state, loading) {
    state.loadingCapitulos = loading;
  },
  SET_LOADING_PARTIDAS(state, loading) {
    state.loadingPartidas = loading;
  },
};

export const actions = {
  obtenerCapitulos({commit}, cancelToken) {
    commit('SET_LOADING_CAPITULOS', true);
    let request = null;
    cancelToken = cancelToken || {};
    cancelToken.cancel = () => {
      request && request.abort();
      commit('SET_LOADING_CAPITULOS', false);
    };
    return PartidasArancelariasService.getCapitulos({
      before(req) {
        request = req;
      },
    })
      .then(r => r.json())
      .then(
        capitulos => {
          commit('SET_LOADING_CAPITULOS', false);
          commit('SET_CAPITULOS', capitulos.list.map(
            mapPartidas
          ));
          return capitulos;
        }
      ).catch(
      (err) => {
        commit('SET_LOADING_CAPITULOS', false);
        throw err;
      }
    );
  },
  buscar({commit, state}, {busqueda, cancelToken}) {
    let request = null;
    cancelToken = cancelToken || {};
    cancelToken.cancel = () => {
      request && request.abort();
    };
    return PartidasArancelariasService.search(busqueda, {
      before(req) {
        request = req;
      },
    })
      .then(r => r.json())
      .then(
        partidas => {
          let mapped = partidas.list ?  partidas.list.map(mapPartidas) : [];
          commit('SET_CAPITULOS', mapped);
          return mapped;
        },
      );
  },
  obtenerHijos({commit, state}, codigo) {
    return PartidasArancelariasService.getChildren(codigo)
      .then(r => r.json())
      .then(
        children => {
          let partidasHijas = children.list.map(mapPartidas);
          commit('ADD_PARTIDAS', partidasHijas);
          let partidaPadre = state.partidasArancelariasFlat.find(p => p.codigo === codigo);
          partidaPadre.children = partidasHijas;
          commit('SET_PARTIDAS_ARANCELARIAS', state.partidasArancelarias);
          return children;
        },
      ).catch(
        (err) => {
          commit('SET_LOADING_PARTIDAS', false);
          throw err;
        }
      );
  },

};

export const getters = {};
